import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ItemComponent } from 'src/app/interfaces/item-container';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import { CNItem } from 'src/app/models/cnitem';
import { CNPrescription } from 'src/app/models/cnprescription';
import { SNUser } from 'src/app/models/snuser';
import { ContactService } from 'src/app/services/contact.service';
import { PrescriptionService } from 'src/app/services/prescription.service';
import { ServicesService } from 'src/app/services/services.service';
import { UserConfigService } from 'src/app/services/user-config.service';
import { UserOpenItemsService } from 'src/app/services/user-open-items.service';
import { ContactComponent } from '../contact/contact.component';

@ManageType('ContactPanelComponent')
@Component({
  selector: 'app-contact-panel',
  templateUrl: './contact-panel.component.html',
  styleUrls: ['./contact-panel.component.scss']
})
export class ContactPanelComponent implements OnInit, OnDestroy, AfterViewInit, ItemComponent {

  @Input() contact: CNConsultation;
  @ViewChild('contactComponent', {static: true}) contactComponentRef: ContactComponent;

  public user: SNUser;
  public searchUserGroups = false;
  private prescriptionUpdatedSub: Subscription;

  constructor(private userOpenItems: UserOpenItemsService, private contactSrv: ContactService,
              private servicesSrv: ServicesService, private userConfig: UserConfigService,
              private prescriptions: PrescriptionService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (!this.user) {
      this.user = this.userConfig.user;
      if (this.userConfig.profileValue('CNUser', 'contact_search_group') &&
          this.userConfig.profileValue('CNUser', 'contact_search_group') === true) {
        this.searchUserGroups = true;
      }
      this.contactSrv.loadContactTypes(this.user);
      this.servicesSrv.loadCodesGroups(this.user);
      if (this.contact) {
        this.contact.healthagentid = this.user.id;
      }
    }
  }

  ngOnDestroy(): void {
      if (this.prescriptionUpdatedSub) {
        this.prescriptionUpdatedSub.unsubscribe();
      }
  }
  /**
   * ItemComponent interface
   */

  @Input() set item(anitem: CNItem) {
    if (anitem instanceof CNConsultation) {
      this.contact = anitem;
      if (this.contact.healthagent) {
        this.user = this.contact.healthagent;
        this.contactSrv.loadContactTypes(this.user);
        this.servicesSrv.loadCodesGroups(this.user);
      }
      this.servicesSrv.loadContactRules(this.contact.type);
    }
  }

  selectType(type: CNConsultationType) {
    this.contactComponentRef.type = type;
    this.userOpenItems.setItemType(this.contact, type);
    this.servicesSrv.loadContactRules(type);
  }

  selectUser(user: SNUser) {
    this.user = user;
    this.contact.healthagentid = this.user.id;
    this.contactSrv.loadContactTypes(user);
    this.servicesSrv.loadCodesGroups(user);
  }

  save() {
    this.contactSrv.save(this.contact);
    this.userOpenItems.removeItem(this.contact);
    // Check if a prescription has been opened and close it
    if (this.contact.havePrescription) {
      this.userOpenItems.removeItem(this.contact.prescription);
    }
  }

  openPrescription() {
    if (!this.contact.havePrescription) {
      // New prescription
      const newPrescription = new CNPrescription();
      this.contact.addChild(newPrescription, false);
    }
    this.userOpenItems.addItem(this.contact.prescription);
    // subscribe to prescription updated event to track
    this.prescriptionUpdatedSub = this.prescriptions.updated.subscribe(updatedPrescription => {
      if (updatedPrescription.id === this.contact.prescription.id) {
        // update prescription
        this.contact.prescription = updatedPrescription;
      }
    });
  }
}
